import { DateTime } from 'luxon';
import { communicationsMethods } from 'const';

export default {
  hasSomeTrueProperty: (value) => Object.values(value).some((element) => element === true),
  containsEmailAndSMSConsent: (value) => value.includes(communicationsMethods.textSms) && value.includes(communicationsMethods.email),
  availabilityValidator: (value, isRequired) => {
    if (isRequired) {
      if (value.morning.length > 0) return true;
      if (value.afternoon.length > 0) return true;
      if (value.evening.length > 0) return true;
      return false;
    }
    return true;
  },
  dateFormatValidator: (value) => {
    const now = DateTime.now();
    const isValidDate = value instanceof DateTime && value.year > 1900;
    const isFutureDate = value > now;
    return isValidDate && !isFutureDate;
  },
  dateFormatFutureValidator: (value) => {
    const now = DateTime.now();
    const isValidDate = value instanceof DateTime && value.year > 1900;
    const isFutureDate = value > now;
    return isValidDate && isFutureDate;
  },
};
